import Vue from "vue";
import $store from "@/store/index.js";
import config from "@/config/config";

export default {
  name: "Card",
  namespaced: true,
  cacheKey: "cart:products",
  state: {
    products: {},
  },
  mutations: {
    addProduct(state, product) {
      state.products = {
        ...state.products,
        [product.vendor_code]: product,
      };
      $store.getters
        .storageLimit(60 * 60 * 12)
        .set(state.cacheKey, state.products);
    },
    changeCount(state, { vendor_code, count }) {
      Vue.set(state.products[vendor_code], "count", count);
      $store.getters
        .storageLimit(60 * 60 * 12)
        .set(state.cacheKey, state.products);
    },
    delProduct(state, vendor_code) {
      Vue.delete(state.products, vendor_code);
      $store.getters
        .storageLimit(60 * 60 * 12)
        .set(state.cacheKey, state.products);
    },
    clear(state) {
      Vue.set(state, "products", {});
      $store.getters.storageLimit().delete(state.cacheKey);
    },
  },

  actions: {
    async createOrder(
      { commit, rootGetters },
      { products, name, firstname, surname, comment, phone, email, context }
    ) {
      let catalogs = [];
      let catalog_ids = [];
      let vendor_codes = [];
      let vendor_codes2 = [];
      let counts = [];
      let labels = [];

      if (typeof products === "object") {
        Object.values(products).forEach(async (product) => {
          catalog_ids.push(product.id);
          vendor_codes.push(product.vendor_code);
          vendor_codes2.push(product.vendor_code2);
          counts.push(product.count);
          labels.push(product.label);

          if (!catalogs[product.id]) {
            catalogs[product.id] = { id: product.id };
          }

          if (product.items) {
            for (const item of product.items) {
              if (item.sku == product.vendor_code) {
                catalogs[product.id].items = catalogs[product.id].items || [];
                catalogs[product.id].items.push({ id: item.id, count: product.count });
                break;
              }
            }
          }
        });
      }
      catalogs = catalogs.filter(_ => true); // reindex
      const params = {
        // name: name,
        // firstname: firstname,
        // surname: surname,
        name: firstname + ' ' + surname,
        phone: phone,
        email: email,
        comment: comment,
        // catalog_id: catalog_ids,
        // vendor_code: vendor_codes,
        // vendor_code2: vendor_codes2,
        catalogs: catalogs,
        // count: counts,
        // label: labels,
        from: "sikayufo.ru",
      };

      const response = await rootGetters.query.post(
        config.api.url.newcrm + "/source/in",
        params,
        false,
        null,
        context
      );

      commit("clear");
      return response;
    },
  },

  getters: {
    total(state) {
      let total = 0;
      Object.values(state.products).forEach((prod) => {
        total += prod.count;
      });
      return total;
    },
    sum(state) {
      let sum = 0;
      Object.values(state.products).forEach((prod) => {
        sum += prod.count * prod.cost;
      });
      return sum;
    },
  },
};
